import { useState, useCallback, useEffect } from "react";
import { useLocation } from "react-router-dom";
import useIsVisible from "./useIsVisible";
import { showDockPaths } from "./useShowDock.paths";

const useShowDock = (initialValue: boolean = false) => {
    const { visible: shown, setVisible } = useIsVisible(initialValue);
    const [path, setPath] = useState('');
    const { pathname } = useLocation();
    const setShown = (isVisible: boolean) => setVisible(isVisible);
    const handleRouteChange = useCallback(() => {
        const shouldShowDock = !!showDockPaths.filter((p) => pathname === p || (p !== '/' && pathname.includes(p))).length;
        setVisible(shouldShowDock);
    }, [pathname, setVisible]);
    useEffect(() => {
        if (path !== pathname) {
            setPath(pathname);
            handleRouteChange();
        }
    }, [pathname, setPath, path, handleRouteChange]);

    return { shown, setShown };
};

export default useShowDock;

